import type { ShortcutGroup } from '../AnnotationStudio/ShortcutHelpDialog';
import { TRANSCRIPT_SHORTCUTS } from '../Transcript/transcriptMarking';

/**
 * The multicam studio's keys: the studio's, plus angles and cuts. In Live cut
 * the number keys cut instead of switching the view; the playback keys work
 * in both views.
 */
export const MULTICAM_SHORTCUTS: ShortcutGroup[] = [
  {
    title: 'Playback',
    items: [
      { keys: ['Space'], label: 'Play / pause' },
      { keys: ['J', 'K', 'L'], label: 'Shuttle back / stop / forward (press again to speed up)' },
      { keys: ['←', '→'], label: 'Back / forward 5 seconds' },
      { keys: ['Shift', '← →'], label: 'Back / forward 10 seconds' },
      { keys: [',', '.'], label: 'Previous / next frame' },
      { keys: ['Home', 'End'], label: 'Start / end of the set' },
      { keys: ['↑', '↓'], label: 'Volume up / down' },
      { keys: ['M'], label: 'Mute' },
      { keys: ['F'], label: 'Full screen' },
    ],
  },
  {
    title: 'Angles, cuts and notes',
    items: [
      { keys: ['1–6'], label: 'Show angle A to F, one key per angle (Review)' },
      { keys: ['C'], label: 'Add a camera cut at the playhead' },
      { keys: ['A'], label: 'Add a note at the playhead' },
      { keys: ['I', 'O'], label: 'Mark In / Out for a range note' },
      { keys: ['Shift', 'L'], label: 'Loop between In and Out' },
      { keys: ['Esc'], label: 'Clear In / Out' },
      { keys: ['[', ']'], label: 'Previous / next note or cut' },
      { keys: ['Enter'], label: 'Add what you are typing' },
    ],
  },
  {
    title: 'Live cut',
    items: [
      { keys: ['1–6'], label: 'Cut to angle A to F on the frame that’s showing (also while paused)' },
      { keys: ['Ctrl / ⌘', 'Z'], label: 'Undo the last live change' },
      { keys: ['Space'], label: 'Play / pause' },
      { keys: ['L'], label: 'Play (every angle plays at normal speed)' },
    ],
  },
  {
    title: 'Timeline',
    items: [
      { keys: ['+', '−'], label: 'Zoom in / out' },
      { keys: ['\\'], label: 'Fit the whole set' },
      { keys: ['Ctrl / ⌘', 'scroll'], label: 'Zoom around the pointer' },
      { keys: ['Alt', '← →'], label: 'Nudge the focused cut or note one frame' },
      { keys: ['?'], label: 'Show these shortcuts' },
    ],
  },
  TRANSCRIPT_SHORTCUTS,
];

/** Fields typed into, where single-key shortcuts must not fire. */
export const isTypingTarget = (target: EventTarget | null) => {
  const el = target as HTMLElement | null;
  if (!el || typeof el.closest !== 'function') return false;
  if (el.isContentEditable) return true;
  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName)) return true;
  return Boolean(el.closest('[role="combobox"], [role="listbox"], [role="menu"], [role="dialog"]'));
};
